// NewMortgageLoanForm.js
import React, {useEffect, useState} from 'react';
import axios from "axios";
import {useNavigate} from "react-router-dom";
import CreateLoan from "./CreateLoan";


const NewVehicleForm = () => {
    const [propulsionType, setPropulsionType] = useState('ICE');
    const [purchaseDate, setPurchaseDate] = useState(null);
    const [vehicleMake, setVehicleMake] = useState('');
    const [vehicleModel, setVehicleModel] = useState('');
    const [vehicleYear, setVehicleYear] = useState('');
    const [selectedNewOrUsedChoice, setSelectedNewOrUsedChoice] = useState('new');
    const [mileage, setMileage] = useState(0);
    const [totalPurchasePrice, setTotalPurchasePrice] = useState(0);
    const [equityFinancingAmount, setEquityFinancingAmount] = useState('');
    const [financingSourceObjects, setFinancingSourceObjects] = useState([]);
    const [selectedFinancingSourceObject, setSelectedFinancingSourceObject] = useState(null); // single selection
    const [titleDocument, setTitleDocument] = useState(null);
    const [isAddNewDebtVisible, setAddNewDebtVisible] = useState(false); // State for add new debt form visibility
    const [vehicleId, setVehicleId] = useState(null); // State to hold the created vehicle ID

    const [error, setError] = useState('');

    const navigate = useNavigate();

        // In the useEffect, keep the fetching logic to populate financingSourceObjects
    useEffect(() => {
        const fetchFinancingSourceObjects = async () => {
            try {
                const response = await axios.get('/api/balance_sheet/assets/physical_assets/vehicles/auto-loan-choices/');
                setFinancingSourceObjects(response.data);
                console.log('Selected Financing Source Object Data:', response.data)
            } catch (error) {
                console.error('Error fetching lender choices:', error);
                setError('Failed to fetch lender choices.');
            }
        };
        fetchFinancingSourceObjects();
    }, []);

    useEffect(() => {

        const userInputEquityAmount = parseFloat(equityFinancingAmount)|| 0; // Default to 0 if no equity amount

        // Use the selected object directly to get the amount
        const selectedAutoLoanAmount = selectedFinancingSourceObject ? parseFloat(selectedFinancingSourceObject.amount) : 0;

        // Calculate new total purchase price
        const newTotal = userInputEquityAmount + selectedAutoLoanAmount;
        setTotalPurchasePrice(newTotal); // Update state with new total
    }, [equityFinancingAmount, selectedFinancingSourceObject]);

    const handleTitleFileChange = (event) => {
        setTitleDocument(event.target.files[0]);
    };

    // Handle form submit
    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            const formData = new FormData();
            // Top-level asset fields
            formData.append('asset_type_1', 'physical_asset');
            formData.append('asset_type_2', 'vehicle');
            if (purchaseDate) formData.append('purchase_date', purchaseDate);
            if (selectedNewOrUsedChoice) formData.append('new_or_used', selectedNewOrUsedChoice);
            if (vehicleMake) formData.append('vehicle_make', vehicleMake);
            if (vehicleModel) formData.append('vehicle_model', vehicleModel);
            if (vehicleYear) formData.append('vehicle_year', vehicleYear);
            if (mileage !== null && mileage !== undefined) formData.append('mileage_at_purchase', mileage);
            if (propulsionType) formData.append('propulsion_type', propulsionType);

            // Total financing (bracketed keys expected by backend)
            if (purchaseDate) formData.append('total_financing[financing_date]', purchaseDate);
            if (equityFinancingAmount !== '' && equityFinancingAmount !== null && equityFinancingAmount !== undefined) {
                formData.append('total_financing[total_equity_amount]', equityFinancingAmount);
            }
            if (selectedFinancingSourceObject && selectedFinancingSourceObject.id) {
                formData.append('total_financing[debt_financing_id]', selectedFinancingSourceObject.id);
            }

            // Initial purchase expense (bracketed keys)
            formData.append('asset_expense_data[expense_category]', 'initial_purchase');
            if (totalPurchasePrice !== null && totalPurchasePrice !== undefined) {
                formData.append('asset_expense_data[amount]', totalPurchasePrice);
            }
            if (purchaseDate) formData.append('asset_expense_data[payment_date]', purchaseDate);
            formData.append('asset_expense_data[expense_desc]', 'Vehicle purchase');

            // Optional title document
            if (titleDocument) {
                formData.append('title_document', titleDocument);
            }

            const response = await axios.post(
                '/api/balance_sheet/assets/physical_assets/vehicles/',
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            navigate(`/balance_sheet/assets/physical_assets/vehicles/${response.data.id}/`);
            setVehicleId(response.data.id);
        } catch (error) {
            console.error('Error creating a new vehicle asset:', error);
            setError('There was an error creating the new vehicle asset. Please check your input.');
        }
    };

  return (
        <div className="container mt-4" style={{marginBottom: '20px'}}>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Purchase
                        Date:</label>
                    <input
                        type="date"
                        value={purchaseDate ? purchaseDate : ""}
                        onChange={(e) => setPurchaseDate(e.target.value ? e.target.value : null)}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                    />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>New or Used:</label>
                    <select
                      id="newOrUsedDropDown"
                      value={selectedNewOrUsedChoice}
                      onChange={(e) => setSelectedNewOrUsedChoice(e.target.value)}
                      className="form-control d-inline-block"
                      style={{ marginLeft: '10px', width: 'calc(100% - 220px)' }}
                    >
                      <option value="new">New</option>
                      <option value="used">Used</option>
                    </select>
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Propulsion Type:</label>
                    <select
                      id="propulsionTypeDropDown"
                      value={propulsionType}
                      onChange={(e) => setPropulsionType(e.target.value)}
                      className="form-control d-inline-block"
                      style={{ marginLeft: '10px', width: 'calc(100% - 220px)' }}
                    >
                      <option value="EV">EV</option>
                      <option value="ICE">ICE</option>
                    </select>
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Vehicle
                        Make:</label>
                    <input
                        type="text"
                        value={vehicleMake}
                        onChange={(e) => setVehicleMake(e.target.value)}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                    />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Vehicle
                        Model:</label>
                    <input
                        type="text"
                        value={vehicleModel}
                        onChange={(e) => setVehicleModel(e.target.value)}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                    />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Vehicle
                        Year:</label>
                    <input
                        type="number"
                        value={vehicleYear}
                        onChange={(e) => setVehicleYear(parseInt(e.target.value, 10))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                    />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{width: '200px', textAlign: 'right'}}>Vehicle
                        Mileage:</label>
                    <input
                        type="number"
                        value={mileage}
                        onChange={(e) => setMileage(parseInt(e.target.value, 10))}
                        className="form-control d-inline-block"
                        style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="financing_source" className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Debt Financing:
                    </label>
                    <select
                        id="financing_source"
                        name="financing_source"
                        value={selectedFinancingSourceObject || ''} // Ensure it can handle null
                        onChange={(e) => {
                            const selectedId = e.target.value;
                            const selectedAutoLoan = financingSourceObjects.find(source => parseInt(source.id) === parseInt(selectedId)); // Find the full object
                            setSelectedFinancingSourceObject(selectedAutoLoan); // Store the entire mortgage object
                            console.log('Selected AutoLoan:', selectedAutoLoan)
                        }}
                        className="form-control d-inline-block"
                        style={{ marginLeft: '10px', width: 'calc(100% - 220px)' }}
                    >
                        <option value="" disabled>Select a loan</option>
                        {financingSourceObjects.map(({ id, lender, amount }) => (
                            <option key={id} value={id}>{`Auto Loan - ${lender} - $${amount.toLocaleString()}`}</option>
                        ))}
                    </select>
                </div>
                {/* Add New Debt Checkbox */}
                <div style={{ marginTop: '10px' }}>
                    <label style={{marginLeft: '215px'}}>
                        <input
                            type="checkbox"
                            onChange={() => setAddNewDebtVisible(!isAddNewDebtVisible)} // Toggle the visibility of the new debt form
                            style={{marginRight: '10px'}}
                        />
                        Create New Auto Loan
                    </label>
                </div>

                {/* Conditional rendering for Add New Debt form */}
                {isAddNewDebtVisible && (
                                  <CreateLoan isOpen={true} onClose={() => setAddNewDebtVisible(false)} />
                                )}

                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Equity Financing:
                    </label>
                        <input
                            type="text"
                            value={equityFinancingAmount} // Format to dollar string
                            onChange={(e) => setEquityFinancingAmount(e.target.value)}
                            className="form-control d-inline-block"
                            style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                            required
                        />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Total Purchase Price:
                    </label>
                        <input
                            type="text"
                            value={`$${totalPurchasePrice.toLocaleString()}`} // Format as currency
                            className="form-control d-inline-block"
                            style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                            readOnly //  Make it read-only since dynamically calculated
                        />
                </div>
                <div className="form-group">
                    <label className="text-right d-inline-block" style={{ width: '200px', textAlign: 'right' }}>
                        Title Document:
                    </label>
                        <input
                            type="file"
                            onChange={handleTitleFileChange}
                            className="form-control d-inline-block"
                            style={{marginLeft: '10px', width: 'calc(100% - 220px)'}}
                        />
                </div>

            <div style={{ marginTop: '20px', marginRight: '20px', textAlign: 'right' }}>
                <button type="submit" className="btn btn-primary">Submit</button>
            </div>
            </form>

            {error && <div className="text-danger">{error}</div>} {/* Display error messages */}
        </div>
    );
};
export default NewVehicleForm;